// this is a dropdown component
// it include the dropdown button and label
// all the setting is passed in using props
// onChange function is in parent
import React from "react";

const Dropdown = (props) => {
  // on load, check the data array has a pre selected value
  // if yes, return the selected value
  // if not, return "DEFAULT"
  // and in selected tag set the defaultValue={selectedValue}
  
  function defaultOnChange(e) {
    if (
      props.getSelectedValue === undefined ||
      props.getSelectedValue === null
    ) {

    } else {

      props.getSelectedValue(e.currentTarget.value);
      props.value(e.currentTarget.value);
      props.onChange(e);
    }
  }

  function defaultOnBlur(e) {

    if (
      props.getSelectedValue === undefined ||
      props.getSelectedValue === null
    ) {

    } else {

      props.getSelectedValue(e.currentTarget.value);
      props.value(e.currentTarget.value);
      props.onBlur(e);
    }
  }

  function defaultOnFocus(e) {

    props.onFocus(true);
    //return true;
  }

  let i = 0;
  return (
    <div className="dropdown__container">
      <label
        className={`dropdown__label ${
          props.isDisabled ? "dropdown__label--disabled" : ""
        }
      ${props.hasError ? "dropdown__label--error" : ""}
      `}
      >
        {props.label}
        <span
          className={`dropdown__required  ${
            props.isRequired
              ? "dropdown__required--show"
              : "dropdown__required--hide"
          }`}
        >
          *
        </span>
      </label>
      <div className="dropdown__div">
        <select
          className={`dropdown__box 
          ${props.hasError ? "dropdown__box--error" : ""}
          `}
          disabled={props.isDisabled ? "disabled" : null}
          //value={selectedValue}
          //defaultValue={"DEFAULT"}
          value={props.selectedItem}
          onChange={(e) => defaultOnChange(e)}
          onBlur={(e) => defaultOnBlur(e)}
          onFocus={(e) => defaultOnFocus(e)}
          id={props.id}
          aria-label={props.label}
        >
          <option
            className="dropdown__instruction"
            value="DEFAULT"
            disabled={props.disableDefault}
            hidden={props.disableDefault} //disableDefault
            key={i++}
          >
          {/* Allows us to set the label for the default selected option. 
          	  Defaults to "Select one" if not passed in as a prop */}
            {props.defaultLabel ? props.defaultLabel : "Select one"}
          </option>
          {props.data.map((item) => (
            <option className="dropdown__item" value={item.value} key={i++}>
              {item.label !== undefined ? item.label : item.title}
            </option>
          ))}
        </select>
      </div>
      <span className="inputbox__help">{props.helpMessage}</span>
      <span
        className="inputbox__error"
        style={props.hasError ? {} : { display: "none" }}
      >
        {props.errorMessage}
      </span>
    </div>
  );
};

export default Dropdown;
